import { ITimeBooking } from "../interfaces/ITimeBooking";

function escapeHtml(text: string): string {
    return text.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;", "'": "&#39;" }[c]!));
}

function minutesToTime(min: number): string {
    return `${Math.floor(min / 60).toString().padStart(2, "0")}:${(min % 60).toString().padStart(2, "0")}`;
}

/**
 * Opens a new tab with all data of a timebooking TimeSafe rejected (e.g. overlapping with an existing entry),
 * so it can be entered in TimeSafe by hand. Falls back to an alert when the browser blocks the tab.
 */
export function showFailedTimeBooking(booking: ITimeBooking, reason: string) {
    const start = new Date(booking.datum);
    const datum = isNaN(start.getTime()) ? booking.datum : start.toLocaleDateString("de-CH");
    const dauer = booking.zeitBisInMinuten - booking.zeitVonInMinuten;

    const rows: [string, string][] = [
        ["Tätigkeit", booking.taetigkeitBezeichnung || `#${booking.taetigkeitID}`],
        ["Tätigkeit-ID", String(booking.taetigkeitID)],
        ["Datum", datum],
        ["Von", minutesToTime(booking.zeitVonInMinuten)],
        ["Bis", minutesToTime(booking.zeitBisInMinuten)],
        ["Dauer", dauer >= 0 ? `${minutesToTime(dauer)} h` : "–"],
        ["Text", booking.textExtern || ""],
        ["Text intern", booking.textIntern || ""]
    ];

    const html = `<!doctype html>
<html lang="de"><head><meta charset="utf-8"><title>Nicht gebuchte Zeit</title>
<style>
  body { font-family: Inter, Arial, sans-serif; margin: 2em; color: #222; }
  h1 { font-size: 1.4em; color: #ea6a47; }
  table { border-collapse: collapse; margin: 1em 0; }
  th, td { text-align: left; padding: 0.4em 1em 0.4em 0; border-bottom: 1px solid #ddd; vertical-align: top; }
  th { color: #5f6a86; font-weight: 600; white-space: nowrap; }
  .grund { background: #fdecea; padding: 0.8em 1em; border-radius: 4px; white-space: pre-wrap; }
</style></head><body>
<h1>Diese Zeitbuchung wurde nicht in TimeSafe gebucht</h1>
<p>TimeSafe hat die Buchung abgelehnt. Die laufende Buchung wurde in Thanos verworfen.
Bitte die Zeit bei Bedarf direkt in TimeSafe erfassen.</p>
<table>${rows.map(([k, v]) => `<tr><th>${escapeHtml(k)}</th><td>${escapeHtml(v)}</td></tr>`).join("")}</table>
<p><strong>Grund laut TimeSafe:</strong></p>
<div class="grund">${escapeHtml(reason)}</div>
</body></html>`;

    const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
    const tab = window.open(url, "_blank");
    if (!tab) {
        // Popup blocked: show the data at least in a dialog, so it is not lost
        const zeilen = rows.map(([k, v]) => `${k}: ${v}`).join("\n");
        alert(`Diese Zeitbuchung wurde nicht in TimeSafe gebucht:\n\n${zeilen}\n\nGrund: ${reason}`);
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
